export interface CareersValue {
  // Which slot on the page this item fills. The page matches on it, so an editor
  // can reorder the list without the layouts moving with it.
  key: string
  title: string
  badgeText: string
  description: string
  image: string
}

interface CareersValueSerializerInput {
  key?: string
  title?: string
  badgeText?: string
  description?: string
  image?: string
}

export function CareersValueSerializer(
  input: CareersValueSerializerInput,
): CareersValue {
  return {
    key: input.key ?? "",
    title: input.title ?? "",
    badgeText: input.badgeText ?? "",
    description: input.description ?? "",
    // Empty means no upload in Strapi. Nothing is bundled with the frontend any
    // more, so an item with no upload renders without an illustration.
    image: input.image ?? "",
  }
}
